import {
    MDBAlert,
    MDBBtn,
    MDBCol,
    MDBDatatable,
    MDBIcon,
    MDBModalFooter,
    MDBRow,
    MDBScrollspy,
    MDBScrollspyLink,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getAADirectorySpecific, getMisc, getSpecificDirectory, updateAAGroup, updateDirectory } from "../../../apiclients/streamsapi_bridge";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
// import DeleteDirectoryUser from "../../../views/popups/autoattendant/DeleteDirectoryUser";
import RemoveToUser from "../../../views/popups/misc/RemoveToUser";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import SaveChanges from "../../topviews/saveCancel";
import { useAdminContext } from "../../adminstore/Admin-Context";
import { useNavigate } from "react-router";
import AADialByNameEditUser from "./AADialByNameEditUser";

const AADialByNameEdit = (props) => {
    const containerRef = useRef(null);
    const [centredModal, setCentredModal] = useState(false);
    const toggleShow = () => setCentredModal(!centredModal);

    const { t, i18n } = useTranslation();
    const [successMessage, setSuccessMessage] = useState("");
    const [message, setMessage] = useState([]);

    const [deleteUserFlag, setDeleteUserFlag] = useState(false);
    const [aadirectoryTypes, setAADirectoryTypes] = useState({});
    const [rerender, setRerender] = useState(false);

    const { isEdited, setEdited } = useAdminContext();



    const [internalError, setInternalError] = useState(false);
    const section1 = useRef(null);
    const section2 = useRef(null);
    // function handleClick() {
    //     addUserRef.current.click();
    // }




    const navigate = useNavigate();




    // function handleClick() {
    //     addUserRef.current.click();
    // }




    const { register, setValue, handleSubmit, formState, reset, setError, setFocus, getValues, watch } = useForm({
        defaultValues: {
            name: "",
            dir_type: 0,



        }

    });
    const { isDirty, errors } = formState;




    useEffect(() => {
        async function getDirectorySpecific() {
            const response = await getSpecificDirectory(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.directoryInfo.id);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                window.alert(`info with id  not found`);
                // navigate("/");
            }

            const direcUser = rawData?.data?.user_info ?? {};
            console.log("getAADirectorySpecific specific :::::::::::::::: " + JSON.stringify(rawData));
            // processUserDtlsFraming(direcUser);
            // setSelectedUsers(direcUser);
            if (props.setdirType) {
                props.setdirType(rawData?.data?.directory_info?.dir_type && parseInt(rawData?.data?.directory_info?.dir_type) === 1 ? "Exclude List" : "Include List");
                props.setDialDirName(rawData?.data?.directory_info?.name ?? "");
            }

            reset({
                name: rawData?.data?.directory_info?.name ?? "",
                dir_type: rawData?.data?.directory_info?.dir_type ? parseInt(rawData?.data?.directory_info?.dir_type) : 0,
            });
            setRerender(false);
        }

        if (props.directoryInfo.id || rerender) {
            getDirectorySpecific();
        }

    }, [props.directoryInfo.id, rerender]);

    useEffect(() => {
        async function getDirectoryTypes() {
            const response = await getMisc(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                { misc: ["directory_type"] }
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const tdata = await response.json();
            if (!tdata) {
                window.alert(`info with id  not found`);
            }
            const directoryType = tdata?.misc?.directoryType ?? {};
            setAADirectoryTypes(directoryType);

        }
        getDirectoryTypes();

    }, []);
    useEffect(() => {
        setEdited(isDirty);
    }, [isDirty])

    useEffect(() => {
        if (successMessage) {
            setMessage(true);
            setTimeout(() => {
                setMessage(false);
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    function closeSave(e) {
        e.preventDefault();
        reset();
        if (props.lunaUser) {
            props.onClose();
        }
    }

    const onSubmit = async (data) => {
        const dirtyFields = formState.dirtyFields;

        if (isDirty) {
            let updates = {
                reqid: 148,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                directory_id: props.directoryInfo.id,
            }
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (field === 'dir_type') {
                        updates[field] = parseInt(data[field]);
                    } else {
                        updates[field] = data[field];
                    }
                }
            }
            console.log("requesst for update :::::::::: " + JSON.stringify(updates));
            let saverep = await updateDirectory(updates);
            console.log(saverep);
            let saverepeMsg = await saverep.json();
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                if (props.lunaUser) {
                    const updateData = {
                        name: data.name,
                        type: data.dir_type,
                        id: props.directoryInfo.id,
                    }
                    props.setisDirectoryEditedData(updateData);
                    props.onClose();
                    props.setSuccessMessage(saverepeMsg.message);

                } else {
                    setRerender(true);
                    setSuccessMessage(saverepeMsg.message);
                }
            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {

                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();
                            fieldElement.scrollIntoView({ behavior: "smooth" });
                        }
                    });
                }
            }
        }
    };

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };

    const [basicActive, setBasicActive] = useState('tab1');

    return (
        <>

            <MDBTabs className='mb-3'>
                <MDBTabsItem>
                    <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                        Settings
                    </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                    <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                        {t("users")}
                    </MDBTabsLink>
                </MDBTabsItem>
            </MDBTabs>

            <MDBTabsContent>
                <MDBTabsPane open={basicActive === 'tab1'}>
                    <form>
                        <MDBRow>

                            <MDBCol
                                size="2"
                                md="2"
                                lg="2"
                                sm="12"
                                className="col-sm-100 pr-0 leftTabs"
                            >
                                <MDBScrollspy container={containerRef}>
                                    <MDBScrollspyLink targetRef={section1}>{t("general")}</MDBScrollspyLink>
                                    {/* <MDBScrollspyLink targetRef={section2}>{t("users")}</MDBScrollspyLink> */}
                                </MDBScrollspy>
                            </MDBCol >


                            <MDBCol size="12" md="10" sm="12" pr-0 className="col-sm-100 pr-0 leftTabContent" style={props.popupAA && { minWidth: "calc(90% - 100px)" }}>
                                <div className={`vtabHeightHunt pr-5 ${props.popupAA && "w-90"}`}>
                                    <div id='element' ref={containerRef} className={`scrollspy-example ${props.popupAA && "mx-0 pe-0 w-100"}`}>

                                        <section ref={section1} id='section-1'>
                                            <h5 className="mb-0">
                                                <div className="general-settings" id="general">
                                                    {t("general")}
                                                </div>
                                            </h5>

                                            <div className="add-numbermain">
                                                <div className="tel-numbers">
                                                    {t("DirectoryName")}
                                                </div>

                                                <div className="form width-100 w-30">
                                                    <input className="form-control" type="text" maxLength={50}
                                                        {...register("name", { required: "Directory name should not be empty" })}
                                                    />

                                                    {errors.name && (
                                                        <p className="text-danger">{errors.name.message}</p>
                                                    )}
                                                    {errors?.directory?.update?.name && (
                                                        <p className="text-danger">{errors.directory.update.name.message}</p>
                                                    )}
                                                </div>
                                            </div>


                                            <div className="add-numbermain-small">
                                                <div>
                                                    <div className="add-numbermain">
                                                        <span>
                                                            {t("DirectoryType")}
                                                        </span>
                                                        <div className="phoneselect width-100 w-30">
                                                            <select className="form-control form-select selectname"
                                                                name="All Users"
                                                                //  {...register("dir_type")}
                                                                // value={dirtype}
                                                                value={watch("dir_type")}
                                                                onChange={(e) => {
                                                                    // setdirType(parseInt(e.target.value));
                                                                    setValue("dir_type", parseInt(e.target.value), { shouldDirty: true })
                                                                }}
                                                            >
                                                                {aadirectoryTypes &&
                                                                    Object.entries(aadirectoryTypes).map(([key, value]) => (
                                                                        <option value={value}>{key}</option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <span className="text-secondary">
                                                        {t("DirectoryTypetxt")}
                                                    </span>
                                                </div>

                                            </div>
                                        </section>

                                    </div>
                                </div>
                            </MDBCol>


                        </MDBRow>
                    </form>
                    {isDirty && (
                        <>
                            {props.lunaUser ? (<>
                                <MDBModalFooter>
                                    <MDBBtn onClick={(e) => closeSave(e)} color="secondary" >
                                        {t("close")}
                                    </MDBBtn>
                                    <MDBBtn onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleSubmit(onSubmit)();
                                    }} color="primary">
                                        {t("save")}
                                    </MDBBtn>
                                </MDBModalFooter>

                            </>) : (<>
                                <SaveChanges
                                    onClose={(e) => closeSave(e)}
                                    isdirtyFields={isDirty}
                                    onSave={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleSubmit(onSubmit)();
                                    }}
                                />
                            </>)}
                        </>

                    )}
                </MDBTabsPane>

                <MDBTabsPane open={basicActive === 'tab2'}>
                    <AADialByNameEditUser
                        directoryInfo={props.directoryInfo}
                        isActive={basicActive === 'tab2'}
                    />


                </MDBTabsPane>
            </MDBTabsContent>






            {/* {isdelete && (
                <PopupLoaderNew
                    title={"Remove User"}
                    content={
                        <RemoveToUser
                            setIsDeleteUser={setIsDeleteUser}
                            onClose={dtogglePopup}
                            ref={addUserRef}
                            setIsloading={setisLoading}

                        />
                    }
                    onShow={setIsDelete}
                    onClose={dtogglePopup}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )} */}
            {successMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{successMessage}</span>
                </MDBAlert>
            )}
        </>
    )

}

export default AADialByNameEdit